module.exports = __webpack_public_path__ + "img/Ah.58fadd96.png";